import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import { LanguageToggle } from './components/LanguageToggle'
import { router } from './router'
import { PricingEngineScreen } from './pages/PricingEngineScreen'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

const PRICING_HOST = 'pricing.yijianmai.com'
const isPricingHost = window.location.hostname === PRICING_HOST

const pricingRouter = createBrowserRouter([
  { path: '/', element: <PricingEngineScreen /> },
  { path: '/pricing', element: <PricingEngineScreen /> },
  { path: '*', element: <PricingEngineScreen /> },
])
const activeRouter = isPricingHost ? pricingRouter : router

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <LanguageProvider>
      <RouterProvider router={activeRouter} />
      <LanguageToggle />
    </LanguageProvider>
  </React.StrictMode>
)
